import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import close from '../Asset/close.svg';
import { Modal, Form } from 'react-bootstrap';
import Table from './tables/fuelTable';
import Alert from './Alert';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Fuel_Tank_Capacity() {
    let userObj = getUserInfo();
    let [sessOut, setSessOut] = useState(false);
    let [ftCapacityList, setFtCapacityList] = useState([]);
    let [showAdd, setShowAdd] = useState(false);
    let [errorMsg, setErrorMsg] = useState({});
    let [cate, setCate] = useState([]);
    let [subCate, setSubCate] = useState([]);
    let [fuelCapData, setFuelCapData] = useState({
        category: "",
        subCategory: "",
        capacity: "",
        btnDis: false
    })
    let [tableList, setTableList] = useState([]);
    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    const handleShow = () => {
        setShowAdd(true);
    }
    function closeModel() {
        setShowAdd(false);

        setFuelCapData({
            category: "",
            subCategory: "",
            capacity: "",
            btnDis: false
        });
        setSubCate([]);
    }
    useEffect(() => {
        getProductCategory();
        getFuelTankCapacity();
    }, [])

    function getFuelTankCapacity() {
        fetch(environment.baseUrl + "getFuelTankCapacity", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    categoryType: "subCategory"
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setTableList(res.data.result)
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setTableList([]);
                }
            })
        })
    }

    function validate() {
        let errror = {};
        if (fuelCapData.category == "") {
            errror.category = "This field is required";
        }
        if (fuelCapData.subCategory == "") {
            errror.subCategory = "This field is required";
        }
        if (fuelCapData.capacity == "") {
            errror.capacity = "This field is required";
        }
        else if (fuelCapData.capacity < 0) {
            errror.capacity = "Enter only positive number";
        }

        setErrorMsg(errror);

        if (Object.keys(errror).length == 0) {
            addFuelCapacity();
        }
    }

    function addFuelCapacity() {
        fetch(environment.baseUrl + "updateProductSubCategory/" + fuelCapData.subCategory, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    "fuelCapacity": fuelCapData.capacity
                })
        }).then((result) => {
            result.json().then(res => {
                setAlert({
                    msg: res.msg,
                    status: true
                })
                closeModel();
                if (res.code == 200) {
                    getFuelTankCapacity();
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
            })
        })
    }

    function getProductCategory() {
        fetch(environment.baseUrl + "getFuelProductCategory?", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setCate(resp.data.result.categories);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setCate([]);
                }
            })
        })
    }

    function getFuelCapData(e) {
        if (e.target.name == "category") {
            setSubCate([]);
            if (e.target.value != "") {
                setFuelCapData({ category: parseInt(e.target.value), subCategory: "", capacity: "" });
                getProductSubCategory(parseInt(e.target.value));
            }
            else {
                setFuelCapData({ category: "", subCategory: "", capacity: "" });
            }
        }
        else if (e.target.value == "") {
            setFuelCapData({ ...fuelCapData, [e.target.name]: e.target.value });
        }
        else {
            setFuelCapData({ ...fuelCapData, [e.target.name]: parseInt(e.target.value) });
            if (e.target.name == "subCategory") {
                let temp = subCate[e.target.selectedIndex - 1].fuelCapacity;
                setFuelCapData({ ...fuelCapData, [e.target.name]: parseInt(e.target.value), capacity: temp != null ? temp : "", btnDis: temp != null ? true : false });
            }
        }
    }

    function getProductSubCategory(pid) {
        fetch(environment.baseUrl + "getFuelProductSubCategory?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    "parentID": pid
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setSubCate(res.data.result.subCategories);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setSubCate([]);
                }
            })
        })
    }


    const columns = useMemo(
        () => [
            {
                Header: 'Product Category ',
                accessor: 'parentName', 
            },
            {
                Header: 'Product Sub-Category ',
                accessor: 'categoryName',
            },
            {
                Header: 'Tank Capacity(Litres)',
                accessor: 'fuelCapacity',
            },
        ],
        []
    )

    return (
        <div className='main-container'>
            <Alert obj={alert} />
            <SessionFun show = {sessOut}></SessionFun>
            <h4 className='main-heading'>Fuel Tank Capacity</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Fuel Tank Capacity</p>

            <div className="card-box-block mt-3" style={{ width: "100%" }}>
                <Table columns={columns} data={tableList}
                    handlemodal={handleShow} />
            </div>

            <Modal show={showAdd} onHide={() => setShowAdd(false)} centered backdrop="static" size="lg">
                <Modal.Header>
                    <Modal.Title>Add Fuel Tank Capacity</Modal.Title>
                    <button onClick={() => setShowAdd(false)} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className="row">
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Product Category<span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Select name="category" className="textbox-back" onChange={getFuelCapData} >
                                    <option value="">Select</option>
                                    {
                                        cate.map((item, index) =>
                                            <option key={index} value={item.categoryID}>{item.categoryName}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{errorMsg.category}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Product Sub-Category<span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Select name="subCategory" className="textbox-back" onChange={getFuelCapData}>
                                    <option value="">Select</option>
                                    {
                                        subCate.map((item, index) =>
                                            <option key={index} value={item.categoryID}>{item.categoryName}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{errorMsg.subCategory}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Tank Capacity(Litres)<span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Control type='number' name="capacity" className="textbox-back" value={fuelCapData.capacity} onChange={getFuelCapData} />
                                <small className='red'>{errorMsg.capacity}</small>
                            </Form.Group>
                        </div>
                    </div>

                    <div className="row text-center mt-3">
                        <div className="col-sm-6">
                            <button className="btn btn-outline-secondary lo-btn float-end" onClick={() => setShowAdd(false)}>
                                Cancel
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={validate} >
                                Save
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Fuel_Tank_Capacity
